module.exports = __webpack_public_path__ + "static/img/logo23.9b0ed71.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo23.png
// module id = l8Xk
// module chunks = 1